/* eslint-disable max-len */
import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {ProjectService} from "../../project/project.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {
  masterAgreementFullLookup,
  masterAgreementLookup,
  deviceIndependentServicePoStatusValues,
  masterAgreementStatusValues,
  deviceTypes,
} from "../../project/master-agreement-status";
import {SuccessComponent} from "../../errors/success.component";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {FormControl, FormGroup} from "@angular/forms";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {SearchHelpers} from "../../helpers/search-helper";
import {MasterAgreementStatus} from "../../project/project.model";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {HighRadiusService} from "../../high-radius/high-radius.service";
import {HighRadiusLogDialogComponent} from "../../high-radius/high-radius-log-dialog.component";
import {CreditCheckLogModel} from "../../high-radius/high-radius.model";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {TARGET_SYSTEM} from "../../helpers/app-constants";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;
@Component({
  templateUrl: "./create-gerp-contract.template.pug",
  providers: [ProjectService, HighRadiusService],
})
export class CreateGerpContractComponent extends WorkflowStep {
  private isReady: boolean = false;

  public projectId: string = "";
  public disableStep: boolean = false;
  public masterAgreementStatus: MasterAgreementStatus;
  public error: Error;
  public message: any;
  public debugManualInternalId: string;
  public toggleDebugControls: boolean = false;
  public toggleValidationErrorDisplay: boolean = true; // Default to visible
  public toggleLastStatusControls: boolean = false;
  public showCreate: boolean = true;
  public showAppend: boolean = false;
  public showRelease: boolean = true;
  public showUpdatePending: boolean = false;
  public showOnboard: boolean = false;
  public showPoRequest: boolean = false;
  public nothingToDo: boolean = false;
  public exportDisabled: boolean = false;
  public validationErrors: string[];
  public deviceIS: any = [];
  public deviceISFiltered: any[] = [];
  public deviceISToShow: any[] = [];
  public enableCreatePO: boolean = false;
  public countDevice: number = 0;
  public enableHighRadiusFlag: boolean = false;
  public targetSystem: string;
  public errorDetails: Error;
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number = 1;
  searchText: string = "";
  highRadiusErrorMessage: any = {};
  firstTimeCreditCheck: boolean = true;
  lastCreditCheckSuccess: boolean = false;
  lastCreditCheckFail: boolean = false;
  lastCreditCheckDate: Date;
  public form: FormGroup = new FormGroup({
    startDate: new FormControl(),
    startDatePicker: new FormControl(),
  });

  lastCreditCheckStatus: CreditCheckLogModel[];
  @ViewChild(SuccessComponent) success: SuccessComponent;
  currentMAStatus;
  POR496_2_flag: boolean = false;
  isNovationProcess: boolean = false;
  private processReturnStatusHelper({success, message, currentStatus}) {
    if (success) {
      this.error = null; // Clear out the previous error
    } else {
      this.error = new Error(message || "The action returned failure, but no reason was provided");
      this.message = null;
    }
    if (currentStatus) {
      this.currentMAStatus = currentStatus;
      if (currentStatus.lastMasterAgreementReturnStatus.receivedDate) {
        currentStatus.lastMasterAgreementReturnStatus.receivedDate =
          currentStatus.lastMasterAgreementReturnStatus.receivedDate.replace(/T/, "    ").replace(/\.[0-9]*Z$/, " UTC");
      }
      this.masterAgreementStatus = currentStatus;
      this.deviceIS = this.masterAgreementStatus.solutions
        .filter(it => it.typeId === deviceTypes.independentService.typeId).map(po => ({
          ...po,
          selected: po.currentPoStatus === deviceIndependentServicePoStatusValues.deviceIndServicePoSuccess.typeId,
        }));
      this.loadFilteredDevices();
      const statusInt = this.masterAgreementStatus.currentMaStatus;
      if (success) {
        if (statusInt === 6 && currentStatus || statusInt === 3 && currentStatus || statusInt === 11 && currentStatus) {
          if (Object.keys(currentStatus.lastMasterAgreementReturnStatus.returnResults).includes("details")) {
            currentStatus.lastMasterAgreementReturnStatus.returnResults.details.message = masterAgreementLookup[statusInt];
          }
          // this.message = currentStatus.lastMasterAgreementReturnStatus.returnResults || "Status Unknown";
          this.error = currentStatus.lastMasterAgreementReturnStatus.returnResults.details;
          let err:any = [];
          if(currentStatus.lastMasterAgreementReturnStatus && currentStatus.lastMasterAgreementReturnStatus.returnResults && currentStatus.lastMasterAgreementReturnStatus.returnResults.details){
          if(Array.isArray(currentStatus.lastMasterAgreementReturnStatus.returnResults.details)){
          for(let value of currentStatus.lastMasterAgreementReturnStatus.returnResults.details){
            err.push(value.Details.contextInformation.errorDetails.split("\\n").map(item => item.replace(/"/g, '')))
          }
          this.errorDetails = err
        } else {
          if(currentStatus.lastMasterAgreementReturnStatus.returnResults.details.Details && currentStatus.lastMasterAgreementReturnStatus.returnResults.details.Details.contextInformation && currentStatus.lastMasterAgreementReturnStatus.returnResults.details.Details.contextInformation.errorDetails){
          err.push(currentStatus.lastMasterAgreementReturnStatus.returnResults.details.Details.contextInformation.errorDetails.split("\\n").map(item => item.replace(/"/g, '')))
          this.errorDetails = err
          }
        }}
        } else {
          this.message = message || masterAgreementLookup[statusInt] || "Status Unknown";
        }
      }
      this.exportDisabled = !!currentStatus.hasHardErrors ||
        this.workflowService.getCurrentStepStatus() === WorkflowStepStatus.Blocked;
      this.validationErrors = currentStatus.validationErrors;

      if (masterAgreementFullLookup[statusInt]) {
        this.showCreate = masterAgreementFullLookup[statusInt].allowed.creation && currentStatus.productsNeedingExport;
        this.showAppend = masterAgreementFullLookup[statusInt].allowed.updating && currentStatus.productsNeedingExport;
        this.showUpdatePending = masterAgreementFullLookup[statusInt].allowed.pendingMessage;
        this.showRelease = masterAgreementFullLookup[statusInt].allowed.releasing;
        this.showOnboard = masterAgreementFullLookup[statusInt].allowed.onboarding;
        this.showPoRequest = this.deviceIS.length && statusInt === masterAgreementStatusValues.itsmOnboarded.typeId;
      } else {
        this.error = new Error("Current state is not recognized. Please contact the TMC team");
        // I don't know how to handle this case
        this.showCreate = false;
        this.showAppend = false;
        this.showUpdatePending = false;
        this.showRelease = false;
        this.showOnboard = false;
        this.showPoRequest = false;
      }

      if (statusInt === masterAgreementStatusValues.partialSuccess.typeId && currentStatus.isAppend === true && currentStatus.productsNeedingExport) {
        this.showCreate = false;
        this.showAppend = true;
      }

      this.nothingToDo = !this.showCreate &&
        !this.showAppend &&
        !this.showUpdatePending &&
        !this.showRelease &&
        !this.showOnboard &&
        !this.showPoRequest;
      if (this.currentMAStatus.projectStatus === "draft") {
        this.isNovationProcess = true;
        this.showCreate = false;
        this.showAppend = false;
        this.showUpdatePending = false;
        this.showRelease = false;
        this.showOnboard = false;
        this.showPoRequest = false;
      }

    }

    this.loading = false;
  }

  private loadFilteredDevices(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.deviceISFiltered = this.deviceIS.filter((g) => {
      if (this.searchText) {
        const values = [
          g.productNumber,
          g.customId,
          g.itemDesc,
        ].filter(it => !!it);

        const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
          .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;

        if (searchFailures) return false;
      }
      return true;
    });
    this.countDevice = this.deviceISFiltered.filter(it => it.selected).length;
    this.deviceISToShow = this.deviceISFiltered.slice(start, end);
    this.maxPages = Math.ceil(this.deviceISFiltered.length / (+this.pageSize));
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.loadFilteredDevices();
  }

  @toggleLoading()
  @handleErrors()
  public async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.isReady = true;
    this.projectId = workflowTargetInfo.targetId;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    let POR496_2 = false, POR496_2_tmc = false;
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["enableHighRadius", "POR496-2", "POR496-2_TMC"]);
    this.enableHighRadiusFlag = featurePermissions["enableHighRadius"];
    POR496_2 = featurePermissions["POR496-2"];
    POR496_2_tmc = featurePermissions["POR496-2_TMC"];
    this.POR496_2_flag = POR496_2 || POR496_2_tmc;
    if (this.enableHighRadiusFlag &&
      ![
        TARGET_SYSTEM.MIGRATION_IPSO_COMPLETE,
        TARGET_SYSTEM.MIGRATION_IPSO_DIRECT_MPS,
        TARGET_SYSTEM.MIGRATION_IPSO_PAGE,
        TARGET_SYSTEM.MIGRATION_ORION,
        TARGET_SYSTEM.MIGRATION_DAAS,
      ].includes(this.targetSystem)) {
      const creditCheckLogs = await this.highRadiusService.getCreditCheckLogs(this.projectId, "");

      if (creditCheckLogs.length) {
        this.lastCreditCheckStatus = creditCheckLogs;
        this.firstTimeCreditCheck = false;
        this.lastCreditCheckSuccess = !creditCheckLogs.some(cc => !cc.responseSuccess);
        this.lastCreditCheckDate = creditCheckLogs[0].createdAt;
        this.lastCreditCheckFail = creditCheckLogs.some(cc => !cc.responseSuccess);
      }
    }
    this.processReturnStatusHelper({
      success: true,
      message: null,
      currentStatus: (await this.projectService.getMasterAgreementStatus(this.projectId)),
    });
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public projectService: ProjectService,
    private appSettingsService: AppSettingsService,
    private highRadiusService: HighRadiusService,
    private dialogService: DialogService,
  ) {
    super(true);
  }

  @toggleLoading()
  @handleErrors()
  async exportMasterAgreement(): Promise<void> {
    this.loading = true;
    if (this.enableHighRadiusFlag) await this.creditCheck(false);
    if (!this.highRadiusErrorMessage.message) this.processReturnStatusHelper(await this.projectService.exportMasterAgreement(this.projectId));
    this.loading = false;
  }

  showCreditCheckLogModal() {
    HighRadiusLogDialogComponent.showModal(this.dialogService, {
      projectId: this.projectId,
      customerBpId: " ",
      selector: "project",
    });
  }

  async creditCheck(maAppend = false) {
    if (maAppend ||
      ![
        TARGET_SYSTEM.MIGRATION_IPSO_COMPLETE,
        TARGET_SYSTEM.MIGRATION_IPSO_DIRECT_MPS,
        TARGET_SYSTEM.MIGRATION_IPSO_PAGE,
        TARGET_SYSTEM.MIGRATION_ORION,
        TARGET_SYSTEM.MIGRATION_DAAS,
      ].includes(this.targetSystem)) {
      const creditCheckLogs = await this.highRadiusService.getCreditCheckLogs(this.projectId, "");

      if (creditCheckLogs.length) {
        this.lastCreditCheckStatus = creditCheckLogs;
        this.firstTimeCreditCheck = false;
        this.lastCreditCheckSuccess = !creditCheckLogs.some(cc => !cc.responseSuccess);
        this.lastCreditCheckDate = creditCheckLogs[0].createdAt;
        this.lastCreditCheckFail = creditCheckLogs.some(cc => !cc.responseSuccess);
      }
      if (this.lastCreditCheckStatus && this.lastCreditCheckStatus.some(data => !!(!data.responseSuccess && data.creditBlockReason))) {
        this.highRadiusErrorMessage = {
          message: "Credit Check is in blocked status for this project, Go to the Credit Request History Report section to release before submitting MA request.",
        };
        window.scrollTo(0, 0);
      } else {
        this.highRadiusErrorMessage = {};
        try {
          this.lastCreditCheckStatus = await this.highRadiusService.highRadiusCreditCheck(this.projectId);
        } catch (e) {
          this.highRadiusErrorMessage = {
            message: "Credit Check System Unavailable. ",
            support: true,
          };
        }
        if (this.lastCreditCheckStatus && this.lastCreditCheckStatus.length) {
          this.firstTimeCreditCheck = false;
          const creditCheckFailData = this.lastCreditCheckStatus.filter(data => !data.responseSuccess);
          if (this.lastCreditCheckStatus.some(ccdata => !!ccdata.error)) {
            const creditCheckError = this.lastCreditCheckStatus.map(ccData => ccData.error);
            this.highRadiusErrorMessage = {
              message: creditCheckError,
            };
          }
          if (creditCheckFailData.length && !this.highRadiusErrorMessage.message) {
            this.lastCreditCheckFail = true;
            this.highRadiusErrorMessage.message = "Credit Check Did Not Pass.";
            this.highRadiusErrorMessage.showEmailNotificationSent = true;
            const creditCheckFailMessage = creditCheckFailData.map(ccData => ccData.response.checkingDescription.messages);
            if (creditCheckFailMessage.length) {
              this.highRadiusErrorMessage.list = creditCheckFailMessage;
            }
          } else if (!creditCheckFailData.length && this.lastCreditCheckStatus.filter(data => data.responseSuccess).length) this.lastCreditCheckSuccess = true;
        }
      }
    }
  }

  @toggleLoading()
  @handleErrors()
  async appendMasterAgreement(): Promise<void> {
    this.loading = true;
    if (this.POR496_2_flag && this.currentMAStatus.isTemplateDartImport) {
      this.processReturnStatusHelper((await this.projectService.appendMasterAgreement(this.projectId, this.form.getRawValue().startDate)));
    }
    else {
      if (this.enableHighRadiusFlag) await this.creditCheck(false);
      if (!this.highRadiusErrorMessage.message) {
        this.processReturnStatusHelper(
          (await this.projectService.appendMasterAgreement(this.projectId, this.form.getRawValue().startDate)),
        );
      }
    }
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async abandonTransaction(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.abandonMasterAgreementTransaction(this.projectId)),
    );
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async debugManuallyAddProject(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.manuallyAddMasterAgreementTransaction(this.projectId, this.debugManualInternalId)),
    );
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async manuallyOnboard(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.manuallySendProjectLevelOnboarding(this.projectId)),
    );
    this.loading = false;
  }

  selectCheckBox(device) {
    device.selected = !device.selected;
    if (device.selected) {
      this.countDevice += 1;
    } else {
      this.countDevice -= 1;
    }
    this.enableCreatePO =
      this.countDevice >
      this.deviceISFiltered.filter(it => it.currentPoStatus ===
        deviceIndependentServicePoStatusValues.deviceIndServicePoSuccess.typeId).length;
  }

  @toggleLoading()
  @handleErrors()
  async emulateOnboard(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.debugEmulateProjectLevelOnboarding(this.projectId)),
    );
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async sendDevIndServPoRequests(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.sendDevIndServPoRequests(this.projectId)),
    );
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async clearDevIndServPoStatus(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.clearDevIndServPoStatus(this.projectId, null)),
    );
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async sendDevIndServ(): Promise<void> {
    this.loading = true;
    const devicesId = this.deviceIS.filter(it => it.selected).map(it => it.deviceId);
    this.processReturnStatusHelper(
      (await this.projectService.sendDevIndServPoRequests(this.projectId, devicesId)),
    );
    this.ready(this.workflowTargetInfo);
    this.enableCreatePO = false;
    this.loading = false;
  }

  @toggleLoading()
  @handleErrors()
  async timeoutPendingPoRequests(): Promise<void> {
    this.loading = true;
    this.processReturnStatusHelper(
      (await this.projectService.timeoutPendingPoRequests(this.projectId, null)),
    );
    this.loading = false;
  }
}
